import API from "./axios";

/**
 * Location expense advances — money given to an employee to run a
 * location's daily expenses, plus the entries booked against each one.
 */
const expenseAdvanceApi = {
  paged:      (params = {})  => API.get("/expense-advances/paged", { params }),
  getById:    (id)           => API.get(`/expense-advances/${id}`),
  entries:    (id)           => API.get(`/expense-advances/${id}/entries`),
  create:     (data)         => API.post("/expense-advances", data),
  update:     (id, data)     => API.put(`/expense-advances/${id}`, data),
  delete:     (id)           => API.delete(`/expense-advances/${id}`),
  addEntry:   (id, data)     => API.post(`/expense-advances/${id}/entries`, data),
  // Employee-first flows: record a spend against the person (the backend
  // picks the oldest advance with money left), and the employee-wise ledger.
  recordEmployeeExpense: (employeeId, data) => API.post("/expense-advances/employee-expense", data, { params: { employeeId } }),
  // params { from, to } (yyyy-mm-dd, both inclusive) narrow the ledger to a
  // period with opening / closing balances; without them it is the whole
  // history, as before.
  employeeLedger:        (employeeId, params = {}) => API.get(`/expense-advances/employee-ledger/${employeeId}`, { params }),
  holders:               ()                 => API.get("/expense-advances/holders"),
  // Every holder for a period: openingBalance (end of the day before from),
  // periodGiven, periodSpent, closingBalance, balanceToday, plus company sums.
  overview:              (params = {})      => API.get("/expense-advances/overview", { params }),
};

export default expenseAdvanceApi;